import React, { Component } from "react";
import { connect } from "react-redux";
import $ from "jquery";
import axios, { CancelToken } from "axios";

import { Translate, I18n } from "react-redux-i18n";

import { setAlert } from "../../../../actions/alertActions";

import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";

class ChangePassword extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;

    this.state = {
      validated: false,

      oldPassword: "",
      newPassword: "",
      repeatPassword: "",
    };

    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleOnSubmit = this.handleOnSubmit.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  validatePassword() {
    if (this.state.newPassword !== this.state.repeatPassword) return false;

    const regex =
      /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$ %^&*-]).{8,}$/;
    return regex.test(this.state.newPassword);
  }

  handleOnChange(e) {
    this.safeSetState({
      [e.target.name]: e.target.value,
    });
  }

  handleOnSubmit(e) {
    e.preventDefault();
    const form = $(e.target)[0];
    this.safeSetState({ validated: true }, () => {
      if (form.checkValidity() !== false && this.validatePassword()) {
        const put = {
          password: this.state.oldPassword,
          newPassword: this.state.newPassword,
          confPassword: this.state.repeatPassword,
        };
        axios
          .put("/api/private/users/changePassword", put, {
            cancelToken: new CancelToken((c) => (this.cancel = c)),
          })
          .then((res) => {
            if (res.status === 200) {
              this.props.setAlert(I18n.t(res.data.message), "primary");
              this.props.onHide();
            }
          })
          .catch((err) =>
            this.props.setAlert(err?.response?.data?.message, "danger")
          );
      }
    });
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    return (
      <Modal
        id="changePassword"
        show={this.props.show}
        onHide={this.props.onHide}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <Translate value="accountDetails_changePassword" />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            id="change-password-form"
            noValidate
            onSubmit={this.handleOnSubmit}
          >
            <Form.Group className="info-field">
              <Form.Label>
                <Translate value="changePassword_currentPassword" />
              </Form.Label>
              <Form.Control
                type="password"
                name="oldPassword"
                value={this.state.oldPassword}
                onChange={this.handleOnChange}
                isValid={this.state.validated && this.state.oldPassword !== ""}
                isInvalid={
                  this.state.validated && this.state.oldPassword === ""
                }
                required
              />
            </Form.Group>
            <Form.Group className="info-field">
              <Form.Label>
                <Translate value="changePassword_newPassword" />
              </Form.Label>
              <Form.Control
                type="password"
                name="newPassword"
                value={this.state.newPassword}
                onChange={this.handleOnChange}
                isValid={this.state.validated && this.validatePassword()}
                isInvalid={this.state.validated && !this.validatePassword()}
                required
              />
            </Form.Group>
            <Form.Group className="info-field">
              <Form.Label>
                <Translate value="changePassword_repeatPassword" />
              </Form.Label>
              <Form.Control
                type="password"
                name="repeatPassword"
                value={this.state.repeatPassword}
                onChange={this.handleOnChange}
                isValid={this.state.validated && this.validatePassword()}
                isInvalid={this.state.validated && !this.validatePassword()}
                required
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <button type="submit" form="change-password-form">
            <Translate value="accountDetails_changePassword" />
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default connect(null, { setAlert })(ChangePassword);
